export default {
    header: {
        greeting: '안녕하세요, {name} 선생님!',
        greetings: {
            morning: '학생과의 하루를 시작할 준비가 되셨나요?',
            lunch: '맛있는 점심시간 되세요!',
            afternoon: '오후 수업도 힘차게 이어가 볼까요?',
            evening: '오늘 수업도 어느덧 마무리되어 가네요.',
            night: '오늘도 수고 많으셨습니다. 편안한 저녁 되세요.',
            lateNight: '늦은 시간까지 고생 많으십니다.',
        },
    },
    achievements: {
        title: '학급 성취도',

        empty: {
            message: '아직 수업 데이터가 없어요',
            instruction: '첫 수업을 진행하면\n 학급 성취도를 확인할 수 있어요',
        },
        score: '{score}점',
        increase: '↑+{score}점',
        decrease: '↓{score}점',
        basedOn: '최근 {count}개 수업',
        basedOnAll: '전체',
        stats: {
            classCount: '수업 수',
            activityCount: '활동 수',
        },
    },
    classTrend: {
        title: '학급 성취도 추이',
        empty: {
            message: '성취도 추이가 없어요',
            instruction: '수업을 진행하면\n 학습 추이를 확인할 수 있어요',
        },
        average: '전체 {score}',
        dropdown: '{count}개',
        averageText: {
            default: '완료한 수업들만 모았어요.',
            weekly: '수업 빈도가 불규칙할 때는 완료한 수업만 모아서 볼 수도 있어요.',
            monthly: '수업 빈도가 불규칙할 때는 완료한 수업만 모아서 볼 수도 있어요.',
            session_5: '완료한 수업을 5회씩 묶어서 보여주고 있어요.',
            session_10: '완료한 수업을 10회씩 묶어서 보여주고 있어요.',
        },
        options: {
            default: '기본',
            weekly: '주간',
            monthly: '월간',
            fiveSession: '5회 단위',
            tenSession: '10회 단위',
        },
        alert: {
            title: '알림',
            message: '수업 데이터가 부족합니다.',
        },
    },
    nextClass: {
        title: '다음 수업 진도',
        empty: {
            message: '다음 수업을 준비해주세요',
            instruction: '수업을 등록하면 여기에 표시됩니다',
        },
        button: {
            viewConfig: '수업 구성 보기',
        },
        date: '{date}',
        participants: '참여 {count}명',
        achievement: '성취도 {score}점',
        lesson: '{number}. {title}',
        session: '{start}~{end}차시 {activity}',
        textbook: '{subject} {page}p',
        buttons: {
            startClass: '수업 시작',
            startSelf: '자습 시작',
            restart: '다시 해보기',
            viewRecords: '기록 보기',
        },
    },
    recentClasses: {
        title: '최근 수업',
        empty: {
            message: '최근 수업이 없어요',
            instruction: '수업을 진행하면 최근 기록이\n 이곳에 표시됩니다',
        },
        state: {
            participants: '참여 {count}명',
            achievement: '성취도 {score}점',
        },
    },
    areaAchievement: {
        title: '학습 영역별 학급 성취도',
        basedOn: '전체 수업 기준',
        empty: {
            message: '학습 영역별 데이터가 없어요',
            instruction: '수업을 통해 다양한 활동을 진행하면\n 각 학습 영역의 성취도를 분석해드려요',
        },
        tabs: {
            overall: '전체',
            vocabulary: '어휘',
            writing: '쓰기',
            grammar: '문법',
            comprehension: '이해 · 추론',
            reading: '읽기 · 말하기',
        },
        achievement: '성취도 <strong>{percent}점</strong>',
        notProvided: '성취도 미제공',
        times: '{count}회',
        areas: {
            seedLetter: '씨앗글자',
            wordSelection: '단어 고르기',
            wordInference: '단어 추리하기',
            dictation: '받아쓰기',
        },
    },
    studentStatus: {
        title: '학생 현황',
        basedOn: '최근 {count}개 수업 기준',
        empty: {
            message: '학생 데이터가 없어요',
            instruction: '학생들이 수업에 참여하면\n 개별 성취도와 학습 현황을 확인할 수 있어요',
        },
        table: {
            number: '출석번호',
            studentName: '학생명',
            praiseStars: '칭찬별',
            mvp: 'MVP',
            champion: '챔피언',
            achievement: '성취도',
            increase: '상승분',
            remarks: '비고',
        },
        remarks: {
            praise: '칭찬',
            interest: '관심',
        },
        infoMessage:
            'ⓘ 상승분은 본인의 전체 성취도 대비 최근 10개 수업의 상승분을 의미해요.  동점자 포함 상승분 상위 3명은 ‘칭찬’, 하위 3명은 ‘관심’ 태그가 표시돼요.',
    },
    experience: {
        title: '매일국어T 활동이 궁금하신가요?',
        description: '체험 수업으로 우리 학급 수업에 어떻게 적용할 수 있을지\n미리 경험해볼 수 있어요',
        buttons: {
            experience: '체험 수업 해보기',
        },
    },
};
